import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions.js'
import mutations from './mutations.js'
import ChatService from "@/services/ChatService";
import WebsiteService from "@/services/WebsiteService";
import WebRTC from "@/services/WebRTC";

import createPersistedState from "vuex-persistedstate";


Vue.use(Vuex)
const store = new Vuex.Store({

    state: {
        id: null,
        token: null,
        language: null,
        /**
         * Thread state
         */
        thread: null,
        state: 2,
        policy_url: "",
        pulseCXUrl: "",
        data_protection_url: "",
        /**
         * Last message id
         */
        lastId: 0,
        agent: {
            name: null,
            isTyping: false
        },

        user: {
            name: null,
            email: null,
            isTyping: false
        },
        business_group: 2,
        system: {
            name: "System"
        },

        chatWindowStatuses: {
            initial: 1,
            waiting: 2,
            active: 3,
            inactive_group: 4,
            waiting_operator: 5,
            queue: 6
        },

        cartInfo: {
            "token": null,
            "share_url": null,
            "quantity_items": 0
        },
        operators: [],
        operator: null,
        groupId: null,
        waitingList: 0,
        isChatOpened: false,
        showLoading: false,
        chatWindowStatus: 1,
        thread_state: 'closed',
        chatType: null,
        chatTypes: [],
        bounce: false,
        bounce_duration: 3000,
        bounce_start: 5000,
        hide_incident_interactions: false,
        hasBounced: false,
        messages: [],
        printedMessages:{},
        hasNewMessages: false,
        chat_rated: false,
        defaultResponses: [],
        appointmentUrls: [],
        incidentInteractions: [],
        baseUrl: process.env.VUE_APP_PWS_BASE_URL,
        baseLogosUrl: process.env.VUE_APP_LOGOS_ROUTE,
        dragActive: false,
        call: false,
        callForm: false,
        audioInput: null,
        audioOutput: null,
        activeVideocall: [],
        isWsActive: false,
        groupsWithCamera: [],
        selectedGroupGotCamera: false,
        operatorGotCameraActive: false,
        isBanned: false,
        bannedTill: null,
        config: {},
        queue_position: 0,
        waiting_time: 0,
        closeByInactivity: false,
        agentTyping: false,
        userTyping: false,
        isChatWindowOpen: true,
        phone_prefix: null,
        greetingText: "Hej!",
        closeChatTime: null,
        contact_phone: null,
        opening_hour: null,
        closing_hour: null,
        isChatAvailable: true,
        isVideoChatAvailable: true,
        // Message set when the backend returns a 403 (origin not in allowed_origin table).
        // Displayed as a banner in SelectSubject.vue. Cleared on every new chat attempt.
        accessBlockedMessage: null
    },
    mutations,
    actions,
    getters: {
        messages: state => {
            return state.messages
        },
        groupId: state =>{
            return state.groupId
        },
        isUserLogged: state => {
            return state.user.name ? true : false
        },
        name: state => {
            return state.user.name
        },
        chatWindowStatusType: state => {
            return Object.keys(state.chatWindowStatuses).find(key => state.chatWindowStatuses[key] === state.chatWindowStatus);
        },
        policyUrl: state => {
            return state.policy_url;
        },
        dataProtectionUrl: state => {
            return state.data_protection_url;
        },
        threadState: state => {
            return state.thread_state;
        },
        shareCartAvailable: state => {
            // Share cart only active in development environment
            var env_available = /^(devserver|devadminserver|islas4dev|localhost|127\.0\.0\.1)/.test(window.location.hostname);
            return env_available && state.cartInfo.quantity_items > 0 && state.cartInfo.token
        },
        cartInfo: state => {
            return state.cartInfo;
        },
        hasNewMessages: state => {
            return state.hasNewMessages;
        },
        chatRated: state => {
            return state.chat_rated;
        },
        defaultResponses: state => {
            return state.defaultResponses;
        },
        incidentInteractions: state => {
            return state.incidentInteractions;
        },
        hideIncidentInteractions: state => {
            return state.hide_incident_interactions;
        },
        baseUrl: state => state.baseUrl,
        baseLogosUrl: state => state.baseLogosUrl,
        agent: state => {
            return state.agent;
        },
        isLoading: state => {
            return state.showLoading;
        },
        isCallActive: state => {
            return state.call
        },
        selectedGroupGotCamera: state => {
            return state.selectedGroupGotCamera
        },operatorGotCameraActive: state => {
            return state.operatorGotCameraActive;
        },
        groupsWithCamera: state => {
            return state.groupsWithCamera
        },
        config: state => {
            return state.config;
        },
        queue_postition: state => {
            return state.queue_position;
        },
        waiting_time: state => {
            return state.waiting_time;
        },
        closeByInactivity: state => {
            return state.closeByInactivity;
        },
        isAgentTyping: state => {
            return state.agent.isTyping;
        },
        isUserTyping: state => {
            return state.user.isTyping;
        },
        phone_prefix: state => {
            return state.phone_prefix;
        },
        greetingText: state => {
            return state.greetingText;
        },
        pulseCXUrl: state => {
            return state.pulseCXUrl;
        },
        contactPhone: state => {
            return state.contact_phone;
        },
        openingHours: state => {
            return state.opening_hour;
        },
        closingHours: state => {
            return state.closing_hour;
        },
        formattedBusinessHours: state => {
            if (!state.opening_hour || !state.closing_hour) {
                return null;
            }

            const isSpanish = state.language === 'es' || state.language === 'sp';

            // Función para formatear hora en formato 12h (inglés)
            const formatTo12Hour = (time) => {
                // Extraer hora y minuto (formato esperado: "HH:MM" o "HH:MM:SS")
                const parts = time.split(':');
                let hour = parseInt(parts[0]);
                const minute = parts[1] || '00';

                const period = hour >= 12 ? 'PM' : 'AM';
                hour = hour % 12 || 12; // Convertir 0 a 12

                return `${hour}:${minute} ${period}`;
            };

            // Función para asegurar formato HH:MM (24h para español)
            const formatTo24Hour = (time) => {
                const parts = time.split(':');
                const hour = parts[0];
                const minute = parts[1] || '00';
                return `${hour}:${minute}`;
            };

            if (isSpanish) {
                return `${formatTo24Hour(state.opening_hour)} a ${formatTo24Hour(state.closing_hour)}h`;
            } else {
                return `${formatTo12Hour(state.opening_hour)} to ${formatTo12Hour(state.closing_hour)}`;
            }
        }
    },
    // The loading overlay is transient: persisting it kept the widget blocked after a reload.
    plugins: [createPersistedState({ reducer: state => ({ ...state, showLoading: false }) })]
})

store.http = new ChatService(store);

//// store.http.on = function(event, callback) {
//     this.socket.on(event, callback);
// };

// store.WebRTC = new WebRTC(store, store.http);
// store.http.webRTC = store.WebRTC;

store.websiteService = new WebsiteService(store);

export default store